//import React, { useState } from "react";
 import  Navbar  from "./Navbar";
//import TemplateForm from "./TemplateForm";
import React, { useState, useEffect, useRef } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { InputTextarea } from "primereact/inputtextarea";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "../api/axios";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

function TablaEmpresas(Authentication) {
  let emptyEmpresa = {
    _id: null,
    numero: 0,
    razonSocial: "",
    rfc: "",
  };

  const [empresas, setEmpresas] = useState(null);
  const [empresaDialog, setEmpresaDialog] = useState(false);
  const [empresa, setEmpresa] = useState(emptyEmpresa);
  const [selectedEmpresas, setSelectedEmpresas] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);
  const axiosPrivate = useAxiosPrivate();
  const getEmpresas = async () => {
    console.log(Authentication.Authentication.RFCS);
    await axiosPrivate.get("/SUA/empresas/"+Authentication.Authentication.RFCS).then((response) => {
      const data = response.data;
      console.log(data);
      setEmpresas(data);
    });
  };

  useEffect(() => {
    getEmpresas();
  }, []);

  const openNew = () => {
    setEmpresa(emptyEmpresa);
    setSubmitted(false);
    setEmpresaDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setEmpresaDialog(false);
  };

  const saveProduct = async () => {
    setSubmitted(true);

    if (empresa.numero > 0) {
      try {
        if (empresa._id) {
          console.log(empresa);
          const response = await axios.put(
            "SUA/empresas/update",
            JSON.stringify({ product: empresa }),
            {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            }
          );
          console.log(response.data);
          getEmpresas();
          toast.current.show({ severity: 'success', summary: 'Successful', detail: response.data.success, life: 3000 });
        }
        else {
          const response = await axios.post(
            "SUA/empresas/new",
            JSON.stringify({ product: empresa }),
            {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            }
          );
          console.log(response.data);
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: response.data.success,
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Error al actualizar la empresa:", error.message);
      }
      setEmpresaDialog(false);
      setEmpresa(emptyEmpresa);
    }
  };

  const editProduct = (product) => {
    setEmpresa({ ...product });
    setEmpresaDialog(true);
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };


  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _product = { ...empresa };

    _product[`${name}`] = val;

    setEmpresa(_product);
  };

  const leftToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <Button
        label="Export"
        icon="pi pi-upload"
        className="p-button-help"
        onClick={exportCSV}
      />
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          className="mr-2"
          onClick={() => editProduct(rowData)}
        />
      </React.Fragment>
    );
  };

  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <h4 className="m-0"> </h4>
      <IconField iconPosition="left">
        <InputIcon className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Busqueda..."
        />
      </IconField>
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog} />
      <Button label="Save" icon="pi pi-check" onClick={saveProduct} />
    </React.Fragment>
  );

  return (
    <div>
      <Toast ref={toast} />
      <div className="card">
        <Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        ></Toolbar>

        <DataTable
          ref={dt}
          value={empresas}
          selection={selectedEmpresas}
          onSelectionChange={(e) => setSelectedEmpresas(e.value)}
          dataKey="numero"
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 25, 50]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products"
          globalFilter={globalFilter}
          header={header}
        >
          <Column selectionMode="multiple" exportable={false}></Column>
          <Column
            field="numero"
            header="Numero"
            sortable
            style={{ minWidth: "12rem" }}
          ></Column>
          <Column
            field="razonSocial"
            header="Nombre"
            sortable
            style={{ minWidth: "16rem" }}
          ></Column>
          <Column
            field="rfc"
            header="RFC"
            sortable
            style={{ minWidth: "10rem" }}
          ></Column>
          <Column
            body={actionBodyTemplate}
            exportable={false}
            style={{ minWidth: "12rem" }}
          ></Column>
        </DataTable>
      </div>

      <Dialog
        visible={empresaDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Detalle de la empresa"
        modal
        className="p-fluid"
        footer={productDialogFooter}
        onHide={hideDialog}
      >
        <div className="field">
          <label htmlFor="numero" className="font-bold">
            Numero
          </label>
          <InputText
            id="numero"
            value={empresa.numero}
            onChange={(e) => onInputChange(e, "numero")}
            required
            autoFocus
            className={classNames({
              "p-invalid": submitted && !empresa.numero,
            })}
          />
          {submitted && !empresa.numero && (
            <small className="p-error">Numero es requerido.</small>
          )}
        </div>
        <div className="field">
          <label htmlFor="razonSocial" className="font-bold">
            Nombre
          </label>
          <InputTextarea
            id="razonSocial"
            value={empresa.razonSocial}
            onChange={(e) => onInputChange(e, "razonSocial")}
            required
            rows={3}
            cols={20}
          />
        </div>
        <div className="field">
          <label htmlFor="rfc" className="font-bold">
            RFC
          </label>
          <InputTextarea
            id="rfc"
            value={empresa.rfc}
            onChange={(e) => onInputChange(e, "rfc")}
            required
            rows={3}
            cols={20}
          />
        </div>
      </Dialog>
    </div>
  );
};

const Empresas = ({ Authentication }) => {
  console.log(Authentication);

  return (
    <>
      <Navbar Authentication={Authentication}/>
      <h1>Empresas</h1>
      <TablaEmpresas Authentication={Authentication} />
    </>
  );
};
// const Container = styled.div`
//   /* height:100vh;*/
//   width: 100vh;
// `;

export default Empresas;
